import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import { isNotEmpty, isEmpty, getSpaceSizeUnit, formatSpaceSize, storageSpaceSizeColors, storageTableExtraInfos } from '../Service/Utils';

import Highlight from 'react-highlight';
import 'highlight.js/styles/vs.css';
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';

import { Link } from 'react-router-dom';
import React from 'react';
import { RedoOutlined, FireOutlined } from '@ant-design/icons';
import { Row, Col, Divider, Space, Table, Tag, Button, Layout, Skeleton, Modal, Form, Select, Input, Rate, Tabs, message } from 'antd';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import moment from 'moment';


class SchemaDetailView extends React.Component {
    constructor() {
        super();
        this.state = {
            extraInfos: [],
            fields: [],
            preview: {
                fields: [],
                rows: [],
                pending: true
            },
            bizInfo: {},
            previewHeight: 600,
            fieldsHeight: 700,
            fieldDetailModal: {
                title: '',
                readonly: true,
                visible: false,
                value: {}
            },
            readonly: true,
            partFields: [],
            visibleSelect: false
        };
    }

    async componentDidMount() {
        const schema = await UIFetchService.get(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/detail`);
        const parts= schema.fields.filter((field) => 
            field.partition)
        this.setState({ ...schema });
       
        let partFields = []
        if (parts.length > 0) {
            parts.map((part) => { partFields.push(part.name)})
            this.setState({partFields: partFields})
        }
        await auth.authenticate();
        this.setState({ admin: auth.allow('datap:admin') });
        this.fetchPreview();

        window.onresize = () => {
            this.setState({
                previewHeight: document.body.clientHeight - 245,
                fieldsHeight: document.body.clientHeight - 340
            });
        }
        window.onresize();

        auth.appendLog(`数据地图-数据仓库-${schema.name}`);
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    render() {
        
        return <>
            <Row>
                <Col>
                    <Link to={`/schema_desc/projects/${this.props.projectName}`}>{"<返回数仓页面"}</Link>
                </Col>
                {auth.allow("datap:admin") && <>
                    <Col flex="auto"></Col>
                    <Col style={{ margin: '0 10px 0 0' }} >
                        <Button type='default' onClick={this.syncSchema.bind(this)} ><RedoOutlined />同步元数据</Button>
                    </Col>
                </>}
            </Row>
            <Divider />
            <Layout>
                <Layout.Sider theme="light" width={360} style={{ textAlign: 'left' }}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>表名</span></Col>
                            </Row>
                            <Row>
                                <Col><code style={{ fontSize: 14, overflowWrap: 'break-word'}}>
                                    {this.state.name}
                                </code></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>负责人</span></Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        {isNotEmpty(this.state.owner) ? this.state.owner.split(':')[1] : ''}
                                    </span>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>创建时间</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.state.createTime}</span></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>最近数据更新时间</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.state.lastDataModifiedTime}</span></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>最近元数据更新时间</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.state.lastMetaModifiedTime}</span></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>表粒度</span></Col>
                            </Row>
                            <Row>
                                {isEmpty(this.state.granularity) 
                                ? <Col><span style={{color: 'gray'}}>[未填写]</span></Col> 
                                : <Col>{this.state.granularity}</Col>}
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>分区字段</span></Col>
                            </Row>
                            <Row>
                            {this.state.partFields.length === 0 
                                ? <Col><span style={{color: 'gray'}}>[不存在]</span></Col> 
                                :<Col>{this.state.partFields.join()}</Col>}
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>分区描述</span></Col>
                            </Row>
                            <Row>
                                {isEmpty(this.state.partitionDesc) 
                                ? <Col><span style={{color: 'gray'}}>[未填写]</span></Col> 
                                : <Col>{this.state.partitionDesc}</Col>}
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>大小</span></Col>
                            </Row>
                            <Row>
                                <Col>{this.makeSpaceSizeNodes(this.state.sizeInBytes)}</Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>分层</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.state.level}</span></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>主题域</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.state.area}</span></Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col><span style={{ fontSize: 12, color: 'gray' }}>表描述</span></Col>
                            </Row>
                            <Row>
                                <Col><em>{this.state.comment}</em></Col>
                            </Row>
                        </div>
                        {isNotEmpty(this.state.remark) && <div><Row>
                            <Col>
                                <Row>
                                    <Col><span style={{ fontSize: 12, color: 'gray' }}>备注</span></Col>
                                </Row>
                                <Row>
                                    <Col><em>{this.state.remark}</em></Col>
                                </Row>
                            </Col>
                        </Row></div>}

                    </Space>
                </Layout.Sider>
                <Layout.Content style={{ margin: '-10px 0px 40px 10px' }}>
                    <Tabs>
                        <Tabs.TabPane tab="字段描述" key="Fields">
                            {this.state.admin && <Row style={{ padding: '10px 0 10px 0'}}>
                                <Space >
                                    {!this.state.editable && <Button
                                        onClick={this.onEditFields.bind(this)}
                                        style={{ margin: '0 10px 0 0' }}
                                    >编辑</Button>}
                                    {this.state.editable && <>
                                        <Button
                                            onClick={this.onAbandonFields.bind(this)}
                                        >放弃</Button>
                                        <Button
                                            type="primary"
                                            onClick={this.onSaveAllFields.bind(this)}
                                        >保存</Button>
                                    </>}
                                </Space>
                                <Space>
                                    <Button
                                        onClick={() => {this.setState({visibleSelect: true})}}
                                        style={{ margin: '0 10px 0 0' }}
                                    >生成SELECT</Button>
                                </Space>
                            </Row>}
                            <Row>
                                <FieldTable
                                    dataSource={this.state.fields}
                                    fieldsHeight={this.state.fieldsHeight}
                                    editable={this.state.editable}
                                    onUpdateRow={(record, field, value) => {
                                        this.setState(({ fields }) => {
                                            record[field] = value;
                                            return { fields };
                                        });
                                    }}
                                    onDbClickRow={(record => this.showFieldDetail(record))}
                                />
                            </Row>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="其他信息" key="BizInfo">
                            <div style={{ height: 20 }}></div>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>表粒度</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.granularity)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <span>{this.state.granularity}</span>}
                                            </Col>
                                            : <Col flex="200px">
                                                <Input
                                                    readOnly={this.state.readonly}
                                                    value={this.state.granularity}
                                                    onChange={({ target: { value } }) => this.setState({ granularity: value })}
                                                ></Input>
                                            </Col>}
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>分区描述</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.partitionDesc)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <span>{this.state.partitionDesc}</span>}
                                            </Col>
                                            : <Col flex="600px">
                                                <Input.TextArea
                                                    readOnly={this.state.readonly}
                                                    value={this.state.partitionDesc}
                                                    rows={2}
                                                    onChange={({ target: { value } }) => this.setState({ partitionDesc: value })}
                                                ></Input.TextArea>
                                            </Col>}
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>数据描述</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.dataDesc)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <span>{this.state.dataDesc}</span>}
                                            </Col>
                                            : <Col flex="600px">
                                                <Input.TextArea
                                                    readOnly={this.state.readonly}
                                                    value={this.state.dataDesc}
                                                    rows={2}
                                                    onChange={({ target: { value } }) => this.setState({ dataDesc: value })}
                                                ></Input.TextArea>
                                            </Col>}
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>使用热度</span></Col>
                                    </Row>
                                    <Row>
                                        <Rate
                                            value={this.state.usageHeat}
                                            character={({ index }) => SchemaDetailView.usageHeatIcons[index + 1]}
                                            disabled={this.state.readonly}
                                            onChange={value => this.setState({ usageHeat: value.toString() })}
                                            style={{ color: '#fa541c' }}
                                        ></Rate>
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>注意事项</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.attention)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <span style={{ color: 'red' }}>{this.state.attention}</span>}
                                            </Col>
                                            : <Col flex="600px">
                                                <Input.TextArea
                                                    readOnly={this.state.readonly}
                                                    value={this.state.attention}
                                                    rows={3}
                                                    onChange={({ target: { value } }) => this.setState({ attention: value })}
                                                ></Input.TextArea>
                                            </Col>}
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>使用说明</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.usage)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <span>{this.state.usage}</span>}
                                            </Col>
                                            : <Col flex="600px">
                                                <Input.TextArea
                                                    readOnly={this.state.readonly}
                                                    value={this.state.usage}
                                                    rows={3}
                                                    onChange={({ target: { value } }) => this.setState({ usage: value })}
                                                ></Input.TextArea>
                                            </Col>}
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col><span style={{ fontSize: 12, color: 'gray' }}>使用案例</span></Col>
                                    </Row>
                                    <Row>
                                        {this.state.readonly
                                            ? <Col style={{ textAlign: 'left' }}>
                                                {isEmpty(this.state.example)
                                                    ? <span style={{ color: 'gray' }}>[未填写]</span>
                                                    : <Highlight languageName="sql" style={{ whiteSpace: 'pre-wrap' }}>{this.state.example}</Highlight>}
                                            </Col>
                                            : <Col flex="600px">
                                                <Input.TextArea
                                                    readOnly={this.state.readonly}
                                                    value={this.state.example}
                                                    rows={3}
                                                    onChange={({ target: { value } }) => this.setState({ example: value })}
                                                ></Input.TextArea>
                                            </Col>}
                                    </Row>
                                </div>

                                {this.state.admin && <div>
                                    <Row>
                                        {this.state.readonly && <Button
                                            onClick={this.onEditBizInfo.bind(this)}
                                        >修改</Button>}
                                        {!this.state.readonly && <Space>
                                            <Button
                                                onClick={this.onAbandonBizInfo.bind(this)}
                                            >放弃</Button>
                                            <Button
                                                type="primary"
                                                onClick={this.onSaveBizInfo.bind(this)}
                                            >保存</Button>
                                        </Space>}
                                    </Row>
                                </div>}
                            </Space>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="数据预览" key="Preview">
                            <Row>
                                <Col flex="100%">
                                    {this.state.preview.pending && <Skeleton active />}
                                    {!this.state.preview.pending && <HotTable
                                        height={this.state.previewHeight}
                                        data={this.state.preview.rows}
                                        rowHeaders
                                        colHeaders
                                        language="zh-CN"
                                        manualColumnResize
                                        manualRowResize
                                        cells={row => {
                                            if (row === 0) {
                                                return { renderer: this.titleRenderer }
                                            } else {
                                                return {};
                                            }
                                        }}
                                        licenseKey="non-commercial-and-evaluation"
                                    >
                                    </HotTable>}
                                </Col>
                            </Row>
                        </Tabs.TabPane>
                    </Tabs>
                </Layout.Content>
            </Layout>
            {this.state.fieldDetailModal.visible && <FieldDetailModal
                {...this.state.fieldDetailModal}
                onClose={this.closeFieldDetail.bind(this)}
                onUpdate={(value) => this.setFieldDetail(value)}
            />}

            {this.state.visibleSelect && <GenerateSelectModal
                visible={this.state.visibleSelect}
                partFieldsOrNot={this.state.partFields.length === 0}
                partField={this.state.partFields[0]}
                tableName={this.state.name}
                dataSource={this.state.fields.map(field => field.name)}
                onCancel = {() => {
                    this.setState({visibleSelect: false})
                }}
            />}
        </>
    }

    bizInfoFields = new Set([
        'granularity',
        'partitionDesc',
        'dataDesc',
        'usageHeat',
        'attention',
        'usage',
        'example'
    ]);

    static usageHeatIcons = {
        1: <FireOutlined />,
        2: <FireOutlined />,
        3: <FireOutlined />,
        4: <FireOutlined />,
        5: <FireOutlined />
    }

    onEditFields() {
        this.savedFields = this.state.fields.map(item => {
            return { ...item };
        });
        this.setState({ editable: true });
    }
    onAbandonFields() {
        this.setState({ fields: this.savedFields, editable: false });
        this.savedFields = [];
    }

    async onSaveAllFields() {
        const request = this.state.fields.map(item => {
            return {
                ...item,
                schemaName: this.props.schemaName,
                schemaSource: 'ODPS',
                fieldName: item.name
            };
        })
        const rv = await UIFetchService.put(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/fields/tags`, request);
        if (typeof rv === 'number' && rv > 0) {
            this.setState({ editable: false });
            this.savedFields = [];
        } else {
            this.onAbandonFields();
        }
    }

    onEditBizInfo() {
        this.savedBizInfo = {};
        for (let key of Object.keys(this.state)) {
            if (this.bizInfoFields.has(key)) {
                this.savedBizInfo[key] = this.state[key];
            }
        }
        this.setState({ readonly: false });
    }

    onAbandonBizInfo() {
        this.setState({ ...this.savedBizInfo, readonly: true });
        this.savedBizInfo = {};
    }

    async onSaveBizInfo() {
        const bizInfo = {};
        for (let key of this.bizInfoFields) {
            bizInfo[key] = this.state[key];
        }
        // /schemas/{name}/tags/biz
        await UIFetchService.put(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/tags/biz`, bizInfo);
        this.setState({ readonly: true });
    }

    closeFieldDetail() {
        this.setState(({ fieldDetailModal }) => {
            fieldDetailModal.visible = false;
            return { fieldDetailModal };
        });
    }

    setFieldDetail(record) {
        const request = {
            schemaName: this.props.schemaName,
            fieldName: record.name,
            schemaSource: 'ODPS',
            ...record
        }
        UIFetchService.put(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/fields/${record.name}/tags`, request)
            .then(async _ => {
                const schema = await UIFetchService.get(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/detail`);
                this.setState({ ...schema });
            });
        this.closeFieldDetail();
    }

    showFieldDetail(record) {
        if (this.state.editable) {
            return;
        }
        this.setState({
            fieldDetailModal: {
                visible: true,
                value: record,
                readonly: !this.state.admin,
                title: '字段信息'
            }
        });
    }

    isPartitioned(partitions) {
        return typeof partitions === 'object' && partitions.length > 0;
    }

    isNotPartitioned(partitions) {
        return !this.isPartitioned(partitions);
    }

    fetchPreview() {
        UIFetchService.get(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/preview`)
            .then(preview => {
                const rows = [];
                rows.push(preview.fields);
                for (let row of preview.rows) {
                    rows.push(preview.fields.map(key => {
                        const value = row[key]
                        if (isEmpty(value) || value === "\\N") {
                            return 'NULL';
                        }
                        return value;
                    }));
                }
                this.setState({
                    preview: {
                        fields: preview.fields,
                        rows,
                        pending: false
                    }
                })
            });
    }

    makeExtraInfosNodes(infos) {
        if (isEmpty(infos[0])) {
            return <Tag color="#595959">内部表</Tag>
        }
        return <Space>
            {infos.map(key => <Tag color={storageTableExtraInfos[key].color}>{storageTableExtraInfos[key].title}</Tag>)}
        </Space>
    }

    makeSpaceSizeNodes(size) {
        if (size === null || size === undefined) {
            return <></>
        }
        const rv = getSpaceSizeUnit(size);
        return <code style={{ color: storageSpaceSizeColors[rv.unit] }}>{formatSpaceSize(size)}</code>
    }

    async syncSchema() {
        const rv = await UIFetchService.post(`/api/v1/utils/querying_works/schemas/sync?names=${this.props.schemaName}`, {});
        if (rv === undefined) {
            return;
        }
        const schema = await UIFetchService.get(`/api/v1/schema/schemas/${this.props.projectName}/${this.props.schemaName}/detail`);
        if (schema === undefined) {
            return;
        }
        this.setState({ ...schema });
        message.success(`更新成功: ${rv.count}`);
    }

    titleRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        Handsontable.renderers.TextRenderer.apply(Handsontable.renderers.TextRenderer,
            [instance, td, row, col, prop, value, cellProperties]);
        td.style.fontWeight = 'bold';
        td.style.color = 'black';
        td.style.background = '#F0F0F0';
    }
}

class FieldTable extends React.Component {

    render() {
        return <Table
            style={{
                width: '100%',
                margin: '0 10px 0 0'
            }}
            size="small"
            //columns={FieldTable.columns}
            dataSource={this.props.dataSource}
            pagination={false}
            //bordered
            scroll={{ y: this.props.fieldsHeight, x: 2200 }}
            onRow={record => {
                return {
                    onDoubleClick: _ => {
                        this.props.onDbClickRow(record);
                    }
                };
            }}
        >
            <Table.Column
                dataIndex="name"
                width={40}
                ellipsis
                fixed="left"
                title="序号"
                render={(value, rd, index)=><Tag color="#108ee9">{index + 1}</Tag>}
            />
            <Table.Column
                dataIndex="name"
                key="name"
                width={100}
                ellipsis
                fixed="left"
                title="字段名"
                sorter={(a, b)=>{
                    if (a.name < b.name) {
                        return -1;
                    } else if (a.name > b.name) {
                        return 1;
                    } else {
                        return 0;
                    }
                }}
                render = {(value, record) => <>
                    <span>{value}</span>
                    {record.partition && <sup style={{ color: '#595959' }}>[{'分区字段'}]</sup>}
                </>
                }
            />
            <Table.Column
                dataIndex="type"
                key="type"
                width={80}
                ellipsis
                title="类型"
                render={
                    value => <code style={{ color: '#2f54eb' }}>{value}</code>
                }
            />
            <Table.Column
                dataIndex="comment"
                key="comment"
                width={150}
                title="字段说明"
                render={value => <em>{value}</em>}
            />
            <Table.Column
                dataIndex="usageDesc"
                key="usageDesc"
                width={100}
                title="描述"
                render={(value, record) => this.props.editable
                    ? <Input
                        value={value}
                        style={{ width: '100'}}
                        onChange={({ target: { value } }) => this.props.onUpdateRow(record, 'usageDesc', value)}
                    />
                    : <span>{value}</span>}
            />
            <Table.Column
                dataIndex="howTo"
                key="howTo"
                width={100}
                title="计算口径"
                render={(value, record) => this.props.editable
                    ? <Input
                        value={value}
                        style={{ width: '100%'}}
                        onChange={({ target: { value } }) => this.props.onUpdateRow(record, 'howTo', value)}
                    />
                    : <span>{value}</span>}
            />
            <Table.Column
                dataIndex="enumValue"
                key="enumValue"
                width={100}
                title="枚举值"
                render={(value, record) => this.props.editable
                    ? <Input
                        value={value}
                        style={{ width: '100%'}}
                        onChange={({ target: { value } }) => this.props.onUpdateRow(record, 'enumValue', value)}
                    />
                    : <span>{value}</span>}
            />
            <Table.Column
                dataIndex="usageHeat"
                key="usageHeat"
                width={80}
                ellipsis
                title="使用热度"
                editable
                render={(value, record) => <Rate
                    value={value}
                    character={({ index }) => SchemaDetailView.usageHeatIcons[index + 1]}
                    onChange={value => this.props.onUpdateRow(record, 'usageHeat', value.toString())}
                    disabled={!this.props.editable}
                    style={{ color: '#fa541c', fontSize: 15 }}
                ></Rate>}
            />
            <Table.Column
                dataIndex="dimKey"
                key="dimKey"
                width={70}
                ellipsis
                title="维度键"
                render={(value, record) => {
                    if (this.props.editable) {
                        return <Select
                            value={value}
                            onChange={value => this.props.onUpdateRow(record, 'dimKey', value)}
                            style={{ width: '100%' }}>
                            <Select.Option value={null}>[未选择]</Select.Option>
                            <Select.Option value={true}>是</Select.Option>
                            <Select.Option value={false}>否</Select.Option>
                        </Select>
                    } else {
                        switch (value) {
                            case true:
                                return <span>是</span>
                            case false:
                                return <span>否</span>
                            default:
                                return <></>
                        }
                    }
                }}
            />
            <Table.Column
                dataIndex="sampleData"
                key="sampleData"
                width={100}
                ellipsis
                title="样例数据"
                render={(value, record) => this.props.editable
                    ? <Input
                        value={value}
                        style={{ width: '100%' }}
                        onChange={({ target: { value } }) => this.props.onUpdateRow(record, 'sampleData', value)}
                    />
                    : <span>{value}</span>}
            />
            <Table.Column
                dataIndex="joinCase"
                key="joinCase"
                width={200}
                ellipsis
                title="关联样例"
                render={(value, record) => this.props.editable
                    ? <Input
                        value={value}
                        style={{ width: '100%' }}
                        onChange={({ target: { value } }) => this.props.onUpdateRow(record, 'joinCase', value)}
                    />
                    : <span>{value}</span>}
            />

        </Table>
    }
};


class FieldDetailModal extends React.Component {

    constructor() {
        super();
        this.state = {
            validate: {}
        };
        this.latestError = 0;
    }

    componentDidMount() {
        //console.log(this.props);
        this.setState(this.props.value);
    }

    render() {
        const formItemStyle = {
            margin: '0px 0px 10px 0px',
        }
        return <Modal
            title={this.props.title}
            visible={this.props.visible}
            onCancel={this.props.onClose}
            footer={!this.props.readonly ? <Row>
                <Col flex="auto"></Col>
                <Col flex="30%">
                    <Space>
                        <Button type="primary" onClick={this.commit.bind(this)} >更新</Button>
                        <Button onClick={this.props.onClose}>关闭</Button>
                    </Space>
                </Col>
            </Row> : <Row justify="space-around">
                <Col>
                    <Button onClick={this.props.onClose}>确定</Button>
                </Col>
            </Row>}
        >
            <Row justify="space-around">
                <Col flex="100%">
                    <Form
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 20 }}
                        layout="horizontal"
                    >
                        <Form.Item
                            {...this.state.validate.name}
                            label="名称"
                            hasFeedback
                            required
                            style={formItemStyle}
                        >
                            <Input
                                readOnly
                                value={this.state.name}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label="描述"
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.usageDesc}
                                onChange={({ target }) => this.updateField('usageDesc', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.enumValue}
                            label="枚举值"
                            //required
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.enumValue}
                                onChange={({ target }) => this.updateField('enumValue', target.value)}
                            >
                            </Input>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.usageHeat}
                            label="使用热度"
                            //required
                            style={formItemStyle}
                        >
                            <Rate
                                value={this.state.usageHeat}
                                character={({ index }) => SchemaDetailView.usageHeatIcons[index + 1]}
                                disabled={this.props.readonly}
                                onChange={value => this.updateField('usageHeat', value.toString())}
                                style={{ color: '#fa541c' }}
                            ></Rate>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.dimKey}
                            label="维度键"
                            //required
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.dimKey}
                                defaultValue={null}
                                disabled={this.props.readonly}
                                onChange={dimKey => this.updateField('dimKey', dimKey)}
                            >
                                <Select.Option value={null}>[未选择]</Select.Option>
                                <Select.Option value={true}>是</Select.Option>
                                <Select.Option value={false}>否</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="计算口径"
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.howTo}
                                onChange={({ target }) => this.updateField('howTo', target.value)}
                                rows={3}
                            ></Input.TextArea>
                        </Form.Item>
                        <Form.Item
                            label="样例数据"
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.sampleData}
                                onChange={({ target }) => this.updateField('sampleData', target.value)}
                                rows={3}
                            ></Input.TextArea>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.joinCase}
                            label="关联样例"
                            //required
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.joinCase}
                                onChange={({ target }) => this.updateField('joinCase', target.value)}
                                rows={3}
                            ></Input.TextArea>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Modal>;
    }

    updateField(name, value) {
        if (this.latestError > 0) {
            this.validate(name, value);
        }
        const update = {};
        update[name] = value;
        this.setState(update);
    }

    commit() {
        this.latestError = this.validate();
        if (this.latestError > 0) {
            return;
        }

        const value = { ...this.state };
        delete value.validate;
        this.props.onUpdate(value);
    }

    validate(name, value) {
        return 0
    }
};

class GenerateSelectModal extends React.Component {

    constructor() {
        super();
        this.state = {
            sql:''
        };
        this.latestError = 0;
    }

    componentDidMount() {
        const domNode = document.getElementById('side-template-editor');
        const selectSql = this.getSql(this.props.dataSource.join(',\n  '))
        this.setState({
            sql: selectSql
        })
        monaco.editor.create(domNode, {
            value: selectSql,
            theme: 'vs-light',
            fontSize: 13,
            language: 'sql',
            minimap: { enabled: false },
            automaticLayout: false
        });
    }

    render() {
        return <Modal
        {...this.props}
        title="生成SELECT语句"
        footer={<>
            <Button onClick={this.copyToClipBoard.bind(this)
            }>复制</Button>
        </>}
        width={570}
        >
        <Row>
            <Col flex='auto' style={{ margin: '0 7px 0 7px' }}>
                    <div id="side-template-editor"
                        style={{
                            textAlign: 'left',
                            border: '1px solid #d9d9d9',
                            height: '500px',
                            width:'500px'
                        }}></div>
             </Col>
        </Row>
  
        </Modal>;
    }

    getSql(sql) {
        if (this.props.partFieldsOrNot) {
            sql = 'SELECT\n  ' + sql+ '\n'+ 'FROM ' + this.props.tableName + ';'
        } else {
            const time = moment().subtract(1, 'days').format('YYYY-MM-DD');
            sql = 'SELECT\n  ' + sql + '\n'+ 'FROM ' + this.props.tableName + '\n' + 'WHERE ' + this.props.partField +'='+ `\'` + time +`\'` + ';'
        }
        return sql
    }

    copyToClipBoard() {
        // if (window.isSecureContext) {
        //     navigator.clipboard.writeText(this.state.sql).then(() => {
        //         message.success("复制成功")
        //     }, () => {
        //         message.error("复制失败")
        //     })
        // } 
        let textArea = document.createElement("textarea");
        textArea.value = this.state.sql;
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise(() => {
            document.execCommand('copy') ?  message.success("复制成功") :  message.error("复制失败");
            textArea.remove();
            this.props.onCancel();
        });
    }
 
};

export default SchemaDetailView;